module.exports = __webpack_public_path__ + "static/media/categorisation.6567fb61.svg";